<template>
  <div class="palette">
    <div class="buttons-box">
      <div class="buttons">
        <button v-for="button in buttons" :key="button.id" :class="buttonClasses(button)" @click="buttonChoice(button)">
          <component class="button-icon" v-if="button.icon" :is="button.icon" />
          <span v-if="button.text">{{ button.text() }}</span>
        </button>
      </div>
    </div>
    <div :class="drawerBoxClasses">
      <div :class="drawerClasses" v-visible="drawerChoices">
        
        <!-- Custom Dropdown for Font Selector -->
        <template v-if="buttonId === 'fontFamily'">
          <div class="custom-select" :class="{ 'is-open': fontDropdownOpen }">
            <button class="custom-select__trigger" :style="{ fontFamily: selections['fontFamily'] || 'var(--font-family-balsamiq)' }" @click.stop="fontDropdownOpen = !fontDropdownOpen">
              <span>ABC</span>
              <ChevronDownIcon :size="20" />
            </button>
            
            <div class="custom-select__options" v-if="fontDropdownOpen">
              <button
                v-for="(choice, choiceIndex) in drawerChoices"
                :title="choice.label"
                :key="choiceIndex"
                :class="{ 'is-active': choice.value === selections['fontFamily'] }"
                :style="choice.style"
                @click.stop="drawerChoice(choice); fontDropdownOpen = false"
              >
                <span>{{ choice.label }}</span>
              </button>
            </div>
          </div>
        </template>

        <!-- Standard Drawer Choices (Color, Alignment) -->
        <template v-else>
          <button
            v-for="(choice, choiceIndex) in drawerChoices"
            :title="choice.label"
            :key="choiceIndex"
            :class="[drawerChoiceClasses(choice), 'drawer-choice-btn']"
            :style="choice.style"
            @click="drawerChoice(choice)"
          >
            <component v-if="choice.icon" :is="choice.icon" :size="16" />
            <span v-if="choice.label" class="choice-label">{{ choice.label }}</span>
          </button>
        </template>
        
      </div>
    </div>
  </div>
</template>

<script>
import FormatAlignLeft from 'vue-material-design-icons/FormatAlignLeft.vue';
import FormatAlignCenter from 'vue-material-design-icons/FormatAlignCenter.vue';
import FormatAlignRight from 'vue-material-design-icons/FormatAlignRight.vue';
import Palette from 'vue-material-design-icons/Palette.vue';
// import Crop from 'vue-material-design-icons/Crop.vue';
import FormatText from 'vue-material-design-icons/FormatText.vue';
// import WhiteBalanceSunny from 'vue-material-design-icons/WhiteBalanceSunny.vue';
import ChevronDownIcon from 'vue-material-design-icons/ChevronDown.vue';

const modalButtons = [ 'fontSize', 'fontFamily', 'textAlign', 'color', 'crop' ];

export default {
  components: {
    ChevronDownIcon
  },
  data() {
    const that = this;
    const colors = [ "#000000", "#FF0000", "#FF7F00", "#FFFF00", "#00FF00", "#0000FF", "#4B0082", "#9400D3", "#FFFFFF" ];
    const data = {
      fontDropdownOpen: false,
      buttons: [
        {
          id: 'fontSize',
          text() {
            return that.selections.fontSize;
          },
          drawer: true,
          def: '24pt',
          choices: [
            {
              label: '10pt',
              value: '10pt'
            },
            {
              label: '16pt',
              value: '16pt'
            },
            {
              label: '24pt',
              value: '24pt'
            },
            {
              label: '32pt',
              value: '32pt'
            },
            {
              label: '48pt',
              value: '48pt'
            },
            {
              label: '60pt',
              value: '60pt'
            },
            {
              label: '90pt',
              value: '90pt'
            },
          ]
        },
        {
          id: 'fontFamily',
          text() {
            return 'ABC';
          },
          drawer: true,
          scroll: true,
          choices: this.$store.state.fonts.map(font => ({
            value: font,
            label: 'ABC',
            style: {
              fontFamily: font,
              paddingRight: '8px',
              fontSize: '16px'
            }
          }))
        },
        {
          id: 'textAlign',
          icon: FormatAlignLeft,
          drawer: true,
          choices: [
            {
              icon: FormatAlignLeft,
              value: 'left',
              label: 'Left'
            },
            {
              icon: FormatAlignCenter,
              value: 'center',
              label: 'Center'
            },
            {
              icon: FormatAlignRight,
              value: 'right',
              label: 'Right'
            }
          ]
        },
        {
          id: 'color',
          icon: Palette,
          drawer: true,
          scroll: true,
          choices: colors.map(color => ({
            value: color,
            class: color === '#FFFFFF' ? 'color-white' : (color === '#000000' ? 'color-black' : 'color'),
            style: {
              width: '40px',
              height: '40px',
              backgroundColor: color
            }
          }))
        },
        // {
        //   id: 'crop',
        //   icon: Crop
        // },
        {
          id: 'text',
          icon: FormatText
        }
        // {
        //   id: 'brightness',
        //   icon: WhiteBalanceSunny
        // }
      ]
    };
    for (const button of data.buttons) {
      if (button.drawer && button.choices) {
        this.$store.commit('setSelection', {
          button,
          value: button.def || button.choices[0].value
        });
      }
    }
    return data;
  },
  computed: {
    button() {
      return this.$store.state.button;
    },
    selections() {
      const state = this.$store.state;
      if (state.itemId) {
        const item = state.items.find(i => i.id === state.itemId);
        if (item && item.type === 'TextItem') {
          return { ...state.selections, ...item.content };
        }
      }
      return state.selections;
    },
    drawerChoices() {
      return this.button && this.button.drawer && this.button.choices;
    },
    drawerClasses() {
      return {
        drawer: true,
        scroll: this.button && this.button.scroll,
        'drawer--font-family': this.button && this.button.id === 'fontFamily'
      }
    },
    drawerBoxClasses() {
      return {
        'drawer-box': true,
        active: modalButtons.includes(this.buttonId)
      };
    },
    buttonId() {
      return this.$store.state.button?.id;
    }
  },
  methods: {
    buttonChoice(button) {
      this.$store.commit('setButton', button);
    },
    drawerChoice(choice) {
      this.$store.commit('setSelection', {
        button: this.button,
        value: choice.value
      });
    },
    buttonClasses(button) {
      if (button.id === this.buttonId) {
        if (modalButtons.includes(this.buttonId)) {
          return {
            active: true
          };
        }
      }
      return {};
    },
    drawerChoiceClasses(choice) {
      const classes = {
        choice: true
      };
      if (choice.class) {
        classes[choice.class] = true;
      }
      if (!this.button.stateless) {
        if (this.button && (choice.value === this.selections[this.button.id])) {
          classes.active = true;
        }
      }
      return classes;
    }
  }
}
</script>

<style scoped>
  .buttons-box {
    width: 100%;
    padding: 4px 19px;
  }
  .buttons {
    height: 42px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }
  .button-icon {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    height: 100%;
  }
  .drawer-box {
    width: 100%;
    padding: 0;
  }
  .drawer-box.active {
    background-color: transparent;
  }
  .drawer {
    height: 40px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    background-color: transparent;
  }
  .drawer.scroll {
    display: block;
    overflow: scroll;
    white-space: nowrap;
    max-width: 100%;
  }
  .drawer--font-family {
    overflow: visible !important;
    height: auto !important;
  }

  /* ── Custom Font Select Dropdown ── */
  .custom-select {
    position: relative;
    width: 200px;
    margin: 16px auto 0;
  }
  .drawer button.custom-select__trigger {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 8px 12px;
    background-color: var(--surface-light, #fdffff);
    border: 2px solid var(--text-dark);
    border-radius: 1px;
    font-size: 16px;
    cursor: pointer;
    filter: url(#button-stroke);
    box-shadow: none;
    height: 40px;
    color: var(--text-dark);
  }
  .custom-select__options {
    position: absolute;
    bottom: 100%; /* Positon above the trigger */
    left: 0;
    width: 100%;
    max-height: 250px;
    overflow-y: auto;
    background-color: var(--surface-dark);
    border: 2px solid var(--text-dark);
    border-radius: 1px;
    z-index: 50;
    display: flex;
    flex-direction: column;
    margin-bottom: 8px; /* gap between trigger and options */
    box-shadow: 0px 4px 6px rgba(0,0,0,0.3);
    filter: url(#button-stroke);
  }
  .drawer .custom-select__options button {
    display: block;
    width: 100%;
    text-align: center;
    padding: 12px;
    height: auto;
    border: none;
    border-bottom: 1px solid rgba(174, 255, 241, 0.2);
    background-color: transparent;
    color: var(--text-bright);
    cursor: pointer;
    font-family: inherit;
    font-size: 16px;
  }
  .drawer .custom-select__options button span {
    font-family: inherit;
  }
  .drawer .custom-select__options button:last-child {
    border-bottom: none;
  }
  .drawer .custom-select__options button:hover {
    background-color: rgba(255,255,255,0.1);
  }
  .drawer .custom-select__options button.is-active {
    background-color: var(--surface-darkest);
    color: var(--text-bright);
  }

  ::-webkit-scrollbar {
      display: none;
  }
  button {
    display: inline-flex;
    height: 38px;
    padding-top: 2px;
    flex-grow: 1;
    margin: 0;
    border: 0;
    color: var(--text-dark);
    background-color: transparent;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    position: relative;
    cursor: pointer;
    font-family: var(--font-family-balsamiq);
    font-size: 14px;
  }
  .drawer button {
    background-color: transparent;
    color: var(--text-dark);
  }

  /* ── Action button style for Alignment choices ── */
  .drawer:not(.scroll) {
    gap: 24px;
    margin-top: 16px;
  }
  .drawer:not(.scroll) button {
    flex-grow: 0;
    width: auto;
    padding: 7px 16px;
    background-color: var(--surface-darkest);
    border: 2px solid var(--text-bright);
    color: var(--text-bright);
    border-radius: 1px;
    filter: url(#button-stroke);
    box-shadow: none;
  }
  .drawer:not(.scroll) button:hover {
    background-color: var(--surface-darker);
  }
  .drawer:not(.scroll) button.active {
    background-color: var(--green-lightest);
    color: var(--text-dark);
    border-color: var(--text-dark);
    filter: none;
  }
  
  /* Icon alignment and label spacing in drawer buttons */
  .drawer button .material-design-icon {
    margin-right: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .drawer button .choice-label {
    font-size: 16px;
    line-height: 24px;
    font-family: var(--font-family-balsamiq);
  }

  /* Keep other active styles for color swatches, etc */
  .choice.color.active {
    box-shadow: inset 0px 0px 4px 2px white;
  }
  .choice.color-white.active {
    box-shadow: inset 0px 0px 4px 2px black;
  }
  .choice.color-black.active {
    box-shadow: inset 0px 0px 4px 2px white;
  }

  /* ── Color swatches — full width horizontal strip ── */
  .drawer.scroll:not(.drawer--font-family) {
    display: flex;
    flex-wrap: nowrap;
    justify-content: center;
    gap: 0;
    background-color: transparent;
  }

  @media screen and (max-width: 560px) {
    /* Color swatches: vertical full-width strips */
    .drawer.scroll:not(.drawer--font-family) {
      display: block;
      height: auto;
      max-height: 260px;
      overflow-y: auto;
      overflow-x: hidden;
      white-space: normal;
    }
    .drawer.scroll:not(.drawer--font-family) .choice {
      display: block;
      width: 100% !important;
      height: 48px !important;
    }
    .custom-select {
      width: 100%;
    }
  }
</style>
